const INGREDIENT_SPECIAL_CASE_TYPES = {
  PARSING_RULE: 'PARSING_RULE',
  IGNORED_COMBINATION: 'IGNORED_COMBINATION',
  DEFAULT_INGREDIENT: 'DEFAULT_INGREDIENT',
}

export default INGREDIENT_SPECIAL_CASE_TYPES
